function rgb(color: string) {
	if (!/^#(?:[\da-f]{3}|[\da-f]{6})$/i.test(color)) return null
	const hex =
		color.length === 4
			? [...color.slice(1)].map((channel) => channel.repeat(2)).join('')
			: color.slice(1)
	return [0, 2, 4].map(
		(offset) => parseInt(hex.slice(offset, offset + 2), 16) / 255
	)
}

function luminance(channels: number[]) {
	return [0.2126, 0.7152, 0.0722].reduce((sum, weight, index) => {
		const channel = channels[index]
		const linear =
			channel <= 0.04045
				? channel / 12.92
				: ((channel + 0.055) / 1.055) ** 2.4
		return sum + weight * linear
	}, 0)
}

export function embroideryInputOutline(thread: string, shoe: string) {
	const foregroundRgb = rgb(thread)
	const backgroundRgb = rgb(shoe)
	if (!foregroundRgb || !backgroundRgb) return 'transparent'
	const foreground = luminance(foregroundRgb)
	const background = luminance(backgroundRgb)
	const ratio =
		(Math.max(foreground, background) + 0.05) /
		(Math.min(foreground, background) + 0.05)
	const [red, green, blue] = foregroundRgb.map(
		(channel, index) => channel - backgroundRgb[index]
	)
	const colorDifference = Math.hypot(red - green, blue - green)
	if (ratio >= 1.6 || colorDifference > 0.125) return 'transparent'
	return foreground > 0.179 ? '#000000' : '#ffffff'
}
